module.exports = __webpack_public_path__ + "img/design-thinking-dark.acb96442.svg";